"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.leave = void 0;
const tslib_1 = require("tslib");
const constants_1 = require("../payloads/constants");
function leave() {
  return tslib_1.__awaiter(this, void 0, void 0, function* () {
    try {
      // if the host is leaving then we need to make someone else the host
      // handle the case where a listner is leaving
      // disconnect with every incoming peer in the mesh connection
      this.data.incoming.slice(1).forEach(_ref => {
        let {
          address
        } = _ref;
        this.disconnect({
          peerAddress: address,
          details: {
            type: constants_1.SPACE_DISCONNECT_TYPE.LEAVE,
            data: {}
          }
        });
      });
    } catch (err) {
      console.error("[Push SDK] - API  - Error - API ".concat(stop.name, " -:  "), err);
      throw Error("[Push SDK] - API  - Error - API ".concat(stop.name, " -: ").concat(err));
    }
  });
}
exports.leave = leave;
//# sourceMappingURL=leave.js.map